import ViewSkinnyProfileReducer from './ViewSkinnyProfileReducer';

export default from './ViewSkinnyProfileContainer';

export const ViewSkinnyProfileReducers = {
  ViewSkinnyProfileReducer,
};
